import React, { Component } from 'react';
import Layout from '../components/layout';
import Logo from '../components/logo';
import RoundResults from '../components/round-results';
import Ranking from '../components/ranking';
import Info from '../components/info';
import Footer from '../components/footer';
import { challengeService } from '../services';
import {Helmet} from "react-helmet";
import IMAGE_SEO from '../assets/images/image-1.png';
import LocalStorageService from '../services/local-storage.service';

class Results extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: [],
      round: 3,
      challenge: null,
      leaderboard: []
    }
  }

  componentDidMount() {
    this.loadChallenge();
  }

  loadChallenge = async () => {
    try {
      let challengeId = this.props.match.params.challenge;
      const response = await challengeService.results(challengeId);
      this.setState({
        challenge: response.data.result,
        leaderboard: response.data.leaderboard,
      });
    } catch(e) {
      this.props.history.push('/');
    }
  }

  startGame = () => {
    LocalStorageService.remove('challenge');
    let session = LocalStorageService.get('session');
    if (session && session.token && session.user) {
      if (session.user._id !== this.state.challenge.user._id) {
        LocalStorageService.clear();
      }
    }

    this.props.history.push('/');
  }

  _renderSeo = () => {
    let title = 'Gameif - ¿Qué tanto sabes de COVID-19?';
    let url = window.location.href;
    let description = 'Pon a prueba todo lo que sabes acerca de Coronavirus, con esta trivia y compara tus resultados con los de otros participantes';
    let image = IMAGE_SEO;
    return (
      <Helmet>
        {/* General tags */}
        <title>{title}</title>
        <meta name="description" content={description} />
        {/* OpenGraph tags */}
        <meta name="og:url" content={url} />
        <meta name="og:title" content={title} />
        <meta name="og:description" content={description} />
        <meta name="og:image" content={image} />
        <meta name="og:type" content="website" />
        {/* <meta name="fb:app_id" content={facebook.appId} /> */}
        {/* Twitter Card tags */}
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:card" content="summary" />
        {/* <meta
          name="twitter:creator"
          content={config.authorTwitterAccount ? config.authorTwitterAccount : ""}
        /> */}
      </Helmet>
    );
  }

  render() {
    const { challenge, leaderboard } = this.state;
    let player = challenge ? challenge.user._id : '';
    return (
      <Layout bgClass="bg-blue">
        { this._renderSeo() }
        <div className="results">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="results-header">
                  <Logo campaign="¿Qué tanto sabes de COVID-19?" textAlign="center" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4">
                { challenge && 
                  <RoundResults 
                    username={challenge.user.name}
                    currentRound={3}
                    challengePoints={challenge.points}
                    rounds={challenge.rounds}
                    restartGame={this.startGame}
                  />
                }
              </div>
              <div className="col-12 col-md-4">
                <Ranking
                  player={player}
                  leaderboard={leaderboard}
                />
              </div>
              <div className="col-12 col-md-4">
                <Info />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Results;